var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 17.3337C13.6022 17.3337 17.3332 13.6027 17.3332 9.00033C17.3332 4.39795 13.6022 0.666992 8.99984 0.666992C4.39746 0.666992 0.666504 4.39795 0.666504 9.00033C0.666504 13.6027 4.39746 17.3337 8.99984 17.3337ZM13.1185 6.05816C13.4439 6.3836 13.4439 6.91124 13.1185 7.23668L8.41257 11.9426C8.25629 12.0988 8.04433 12.1866 7.82332 12.1866C7.60231 12.1866 7.39034 12.0988 7.23406 11.9426L4.88112 9.58962C4.55569 9.26418 4.55569 8.73654 4.88112 8.41111C5.20656 8.08567 5.7342 8.08567 6.05963 8.41111L7.82332 10.1748L11.9399 6.05816C12.2654 5.73273 12.793 5.73273 13.1185 6.05816Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckSmall);
export default __webpack_public_path__ + "static/media/ic_check_small.0f4f835943c468cf35c0957044c8415c.svg";
export { ForwardRef as ReactComponent };